import { PickType } from '@nestjs/swagger';

import { JobPhaseBumpPaidDto } from './job-phase-bump-paid.dto';
import { JobPhaseBumpNoteCreatableInterface } from 'src/modules/job-phase-bump-note/interfaces/job-phase-bump-note-creatable.interface';
import { JobPhaseBumpPaidCreatableInterface } from '../interfaces/job-phase-bump-paid-creatable.interface';

export class JobPhaseBumpPaidCreateDto
  extends PickType(JobPhaseBumpPaidDto, ['paid', 'jobPhaseBumpId'])
  implements JobPhaseBumpPaidCreatableInterface {}
